import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'ras-box-banner',
	templateUrl: './box-banner.component.html',
	styleUrls: ['./box-banner.component.sass']
})
export class BoxBannerComponent implements OnInit {

	constructor() { }

	ngOnInit(): void {
	}

}
